import { api } from "../api";

/**
 * checklistsFindAllByActivated - Function that finds on database all checklists
 * /checklists/{status} 
 * method GET 
 * @async-function
 */
const checklistsFindAllByActivated = async (token: string, customerId: number, vehicleId: number, status: string, page: number, size: number) => {
    const response = await api.get(
        `/checklists/${customerId}/${vehicleId}/${status}?page=${page}&size=${size}`, {
            headers: {
                'Authorization': `Bearer ${token}`
            }
         }
    );
    return response;
};

export default checklistsFindAllByActivated;